import { useLocation } from 'lib/router'

const useQueryParam = () => new URLSearchParams(useLocation().search)

export default useQueryParam
